/** @format */
import axios from 'axios';

import { validationMessagesInterceptor } from '@toucan/services/interceptors/validation-messages';

import { changeCaseInterceptor } from '@toucan/client/global/axios/helpers/interceptors/change-case';

export type FormValues = Record<string, string | boolean>;

export function escapeValues(values: FormValues): FormValues {
    const escaped: FormValues = {};
    Object.keys(values).forEach((key) => {
        if (Object.keys(values).includes(key)) {
            escaped[key] = encodeURIComponent(values[key]);
        }
    });
    return escaped;
}

const client = axios.create();

// Rename object keys to and from the API so we can model our data in camelCase
// But send and receive in snake_case for the pythons.
client.interceptors.request.use(
    changeCaseInterceptor.requestFulfilled,
    undefined
);
client.interceptors.response.use(
    changeCaseInterceptor.responseFulfilled,
    changeCaseInterceptor.responseRejected
);

// Move validation messages to the top level of the error
client.interceptors.response.use(
    undefined,
    validationMessagesInterceptor.responseRejected
);

export { client };
